import type { Gender } from '@entities/saju'

const STORAGE_KEY = 'saju-saved-user-info'

export interface SavedUserInfo {
  name: string
  birthYear: string
  birthMonth: string
  birthDay: string
  birthTime: string
  gender: Gender
  isLunar: boolean
  savedAt: number
}

export function getSavedUserInfo(): SavedUserInfo | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return null
    }
    return JSON.parse(raw) as SavedUserInfo
  } catch {
    return null
  }
}

export function setSavedUserInfo(info: Omit<SavedUserInfo, 'savedAt'>): void {
  const data: SavedUserInfo = { ...info, savedAt: Date.now() }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
}

export function removeSavedUserInfo(): void {
  localStorage.removeItem(STORAGE_KEY)
}
